export const LAPTOP_SIZE_BREAKPOINT_PX = 768;
export const LAPTOP_SCREEN_MQ = `screen and (min-width: ${LAPTOP_SIZE_BREAKPOINT_PX}px)`;
export const MOBILE_SCREEN_MQ = `screen and (max-width: ${
  LAPTOP_SIZE_BREAKPOINT_PX - 1
}px)`;
export const LONG_SCREEN_MOBILE_MQ = `${MOBILE_SCREEN_MQ} and (min-height: 800px)`;
export const LANDSCAPE_MOBILE_MQ = `screen and (orientation: landscape) and (max-height: 500px) and (pointer: coarse)`;
export const SHORT_LANDSCAPE_MOBILE_MQ = `screen and (orientation: landscape)  and (max-height: 363px) and (pointer: coarse)`;

export const MDX_MIN_CONTENT_WIDTH_PX = 480;
export const MDX_MAX_CONTENT_WIDTH_PX = 1018;
export const MDX_MODAL_MAX_CONTENT_WIDTH_PX = 677;

export const MDX_MIN_CONTENT_WIDTH = `${MDX_MIN_CONTENT_WIDTH_PX}px`;
export const MDX_MAX_CONTENT_WIDTH = `${MDX_MAX_CONTENT_WIDTH_PX}px`;
export const MDX_MODAL_MAX_CONTENT_WIDTH = `${MDX_MODAL_MAX_CONTENT_WIDTH_PX}px`;

export const ADAPTIVE_VIEWPORT_MIN_WIDTH_PX = 1024;
export const ADAPTIVE_VIEWPORT_MAX_WIDTH_PX = 1728;
export const ADAPTIVE_VIEWPORT_2K_WIDTH_PX = 2048;

export const ADAPTIVE_VIEWPORT_MIN_WIDTH = `${ADAPTIVE_VIEWPORT_MIN_WIDTH_PX}px`;
export const ADAPTIVE_VIEWPORT_MAX_WIDTH = `${ADAPTIVE_VIEWPORT_MAX_WIDTH_PX}px`;
